import { SurfaceDefect } from "@/shared/models/Inspection";
import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (surfaceDefect: SurfaceDefect) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	handleNewSurfaceDefect: () => void;
};

export const useSurfaceDefectOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	handleNewSurfaceDefect,
}: Props) => {
	const getMenuOptions = (data: SurfaceDefect) => {
		const options: MenuOptionType[] = [
			{
				name: "New Surface Defect",
				key: "new_surface_defect",
				onClick: handleNewSurfaceDefect,
				icon: <PlaylistAddIcon />,
			},
		];

		if (data) {
			options.push(
				{
					name: "Edit Surface Defect",
					key: "edit_surface_defect",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Surface Defect",
					key: "delete_surface_defect",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			);
		}

		return options;
	};

	return { getMenuOptions };
};
